
import { BaseComponent,MyFile } from '@/decorators';
import { Component } from 'vue-property-decorator';
import api from '@/utils/api'
import CheckForm from './Check.vue'
import Config from '@/utils/config';
@Component({
    components: { CheckForm }
})
export default class CheIndex extends BaseComponent {
    mode = '待处理';
    Files = new Array<MyFile>();

    Model = {
        carID: null,
        begin: null,
        finish: null,
        remark: null,
        to:null,
        line:null,
        phone:null
    }
    Title = "用车申请";
    Cols = [
        { slot: 'templateName', minWidth: 130, title: '名称' },
        { slot: 'car', minWidth: 130, title: '车辆信息' },
        
        { slot: 'time', minWidth: 200, title: '用车时间' },
        { slot: 'remark', title: '用车事由', minWidth: 295, },
        { slot: 'to', minWidth: 120, title: '目的地' }, 
        { slot: 'status', title: '状态', minWidth: 108, maxWidth: 108, },
        // { slot: 'nodeUserName', title: '当前节点', minWidth: 100, maxWidth: 100, },
        { title: '创建时间', slot: 'createdTime', minWidth: 180, maxWidth: 180, show: true },
        { slot: 'action', title: '操作', minWidth: 145, maxWidth: 185 ,fixed:'right'},
    ];
    Loading = true;
    List = new Array<any>();


    async mounted() {
        await this.Init();
    }

    async Init() {
        this.mode = this.mode;
        this.Query = { name: '', };
        this.ChangeMode(this.mode);
        this.Model = {             
            carID: null,
            begin: null,
            finish: null,
            remark: null,
            to:null,
            phone:null,
            line:null
        };
        this.IsEdit = false;
        this.Row = null;
        this.$refs.PageView.showModal = false;
        this.InitPager();
    }
    async ChangeMode(e: string) {
        if (e == '待处理')
            this.Query.mode = 0;
        if (e == '已处理')
            this.Query.mode = 1;
        if (e == '我发起的')
            this.Query.mode = 2;
        if (e == '全部')
            this.Query.mode = 3;

        await this.FetchData();
    }

    async FetchData() {
        let res = await api.Che.Query(this.Pager, this.Query);
        if (res.status == 200) {
            this.List = [...res.data.data];
            this.Pager.total = res.data.count;
            this.Loading = false;
        }
    }

    async Save() {
        let res;
        if (this.IsEdit) {
            try{
                res = await api.Che.Edit({ id: this.Row.id, ...this.Model });
                
            }catch(error:any){
                this.$Notice.error({ title: error.message });
                return;
            }

        } else {
            res = await api.Che.Create(this.Model);
        }

        if (res.status == 200 || res.status == 201) {
            this.$Notice.success({ title: '保存成功!' });
            await this.Init();
        }
    }
    async Publish() {
        let payload = { id: this.Row.id, remark: this.Remark };
        let res = await api.Che.Publish(payload);
        if (res.status == 200 && res.data) {
            this.$Notice.success({ title: '操作成功!' });
            this.CloseCheck();
            await this.Init();
        }
    }

    async Reject() {
        if (!this.Remark) {
            this.$Message.error('请输入驳回原因');
            return;
        }
        let payload = { id: this.Row.id, remark: this.Remark };
        let res = await api.Che.Reject(payload);
        if (res.status == 200 && res.data) {
            this.$Notice.success({ title: '操作成功!' });
            this.CloseCheck();
            await this.Init();
        }
    }

    OpenCheck(row: any) {
        this.Row = { ...row };
        this.ShowDrawer = true;
        // this.Remark = row.steps.find((s:any)=>s.userID== this.UserID).content;
    }
    CloseCheck() {
        this.ShowDrawer = false;
        this.Remark = '';
        this.Row = null;
    }
    OpenCancelModal(id: any) {
        this.$Modal.confirm({
            title: '提示',
            content: '当前申请已在审批流程中，确认是否取消当前申请？',
            onOk: async () => {
                let res = await api.Che.Cancel(id);
                if (res.status == 200 && res.data) {
                    await this.Init();
                    this.$Notice.success({ title: '撤销成功' });
                } else {
                    this.$Notice.error({ title: '撤销失败' });
                }

            }
        });
    }
    OpenEditModal(row: any) {
        this.$refs.PageView.showModal = true;
        this.IsEdit = true;
        this.Model = { ...row };
        this.Row = { ...row };
        this.Title = "编辑用车申请";
    }
    OpenModal() {
        this.$refs.PageView.showModal = true;
        this.Title = "用车申请";
    }
    OVC(e: boolean) {
        if (e) {
        } else {
            this.Model = {
                carID: null,
                begin: null,
                finish: null,
                remark: null,
                to:null,
                phone:null,
                line:null
            }
        }
    }


    options3: any = {
        disabledDate: (date: Date) => {
            return date && date.valueOf() < Date.now() - 86400000;
        }
    };

    dopc(e:any){
        if (e){
            // this.options3 = {
            //     disabledDate: (date: Date) => {
            //         if (this.Model.begin){
            //             return date && date.valueOf() < this.Model.begin - 86400000;
            //         }else{
            //             return date && date.valueOf() < Date.now() - 86400000;
            //         }

            //     }
            // }
        }
    }


    ShowReturn: boolean = false;
    IsReturning:boolean = true;
    ToggleReturnModal(row: any) {
        this.ShowReturn = true;
        this.Row = { ...row };
        this.ReturnModel.flowID = row.id;
    }

    async SaveReturn(){
        if(!this.ReturnModel.recoredMileage || this.ReturnModel.recoredMileage == 0){
            this.$Notice.error({ title: '请输入当前里程' });
            this.IsReturning = false;
            this.$nextTick(()=>this.IsReturning = true);
            return;
        }
        if(this.ReturnModel.recoredMileage<this.Row.beginMileage){
            this.$Notice.error({ title: '当前里程不能小于出车前里程' });
            this.IsReturning = false;
            this.$nextTick(()=>this.IsReturning = true);
            return;
        }
        // if(!this.ReturnModel.recoredOil || this.ReturnModel.recoredOil == 0){
        //     this.$Notice.error({ title: '请输入当前油量' });
        //      this.IsReturning = false;
        //     this.$nextTick(()=>this.IsReturning = true);
        //     return;
        // }


        let  res = await api.Return.Create(this.ReturnModel);
        if (res.status == 200 || res.status == 201) {
            this.$Notice.success({ title: '还车申请已提交!' });
            this.IsReturning = true;
            this.ShowReturn = false;
            await this.Init();
        }
    }

    ReturnModel = {
        files: '',
        oilState: 1,
        recoredOil: 0,
        recoredMileage: 0,
        flowID: undefined,
    }

    FinishUploadFiles(res: any) {
        if (res.status == 200) {
            let array = this.ReturnModel.files == '' ? new Array<string>() : this.ReturnModel.files.split(/,/);

            array.push(res.data);

            this.ReturnModel.files = array.join(',');
        }
    }

     RemoveFile(file:any, fileList:any){
       
        let array = this.ReturnModel.files == '' ? new Array<string>() : this.ReturnModel.files.split(/,/);
        array = array.filter((f)=>f!=file.name);

        this.ReturnModel.files = array.join(',');
       //  console.log(this.ReturnModel.files);
    }

    Action = `${Config.BASE_API}api/File/car`;
    Folder = `${Config.BASE_UPLOAD}/car`;

    getFile(flow:any,file:string) : string {
        // var time = new Date(flow.createdTime);
        var time = new Date();
        var year = time.getFullYear();
        var month = time.getMonth()+1;
        return `${this.Folder}/${year}-${month}/${file}` ;
    }
    
}
